import { render, staticRenderFns } from "./deleteNoticeEmployee.vue?vue&type=template&id=051b50ef"
import script from "./deleteNoticeEmployee.vue?vue&type=script&lang=js"
export * from "./deleteNoticeEmployee.vue?vue&type=script&lang=js"
import style0 from "./deleteNoticeEmployee.vue?vue&type=style&index=0&id=051b50ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports